@if (release$ | async) {}
@if (action$ | async) {}
@if (downloadArtifact$ | async) {}
@if (downloadReleaseDoc$ | async) {}

<nz-page-header nzBackIcon nzTitle="Релиз" (nzBack)="goBack()">
  <nz-page-header-content>
    <nz-descriptions nzSize="small" [nzColumn]="3">
      <nz-descriptions-item nzTitle="Версия" [nzSpan]="1">
        {{ releaseVersion$ | async }}
      </nz-descriptions-item>
    </nz-descriptions>
  </nz-page-header-content>
</nz-page-header>

<div nz-col class="table-wrapper">
  @if (artifacts$ | async; as artifacts) {
    @if (!(loading$ | async) && artifacts.length > 0) {
      <div class="cards-header">
        <h4 nz-typography>Артефакты</h4>
        @if (releaseService.artifacts.value.length > 1) {
          <button
            nz-button
            nzShape="round"
            [nzLoading]="isDownloadingAllArtifacts"
            (click)="downloadAllArtifacts()"
          >
            <i nz-icon nzType="download"></i>
            Скачать все
          </button>
        }
      </div>

      <nz-table #basicTable nzBordered [nzData]="artifacts">
        <thead>
          <tr>
            <th>Название</th>
            <th>Описание</th>
            <th>Хэш</th>
            <th>Версионирование</th>
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track $index) {
            <tr>
              <td>
                <div class="artifact-content-name">
                  <nz-typography
                    nz-tooltip
                    nzEllipsis
                    nzTooltipPlacement="top"
                    [nzEllipsisRows]="2"
                    [nzTooltipTitle]="data.contentName"
                  >
                    {{ data.contentName }}
                  </nz-typography>
                  @if (data.contentName?.includes(".deb")) {
                    <i
                      nz-icon
                      nz-tooltip
                      nzType="info-circle"
                      class="deb-info"
                      nzTooltipTitle="Открыть инструкцию по верификации"
                      (click)="openVerificationModal()"
                    ></i>
                  }
                </div>
              </td>
              <td>
                <nz-typography
                  nz-tooltip
                  nzEllipsis
                  nzTooltipPlacement="top"
                  [nzEllipsisRows]="5"
                  [nzTooltipTitle]="
                    getDescriptionTooltipTitle(
                      data.projectName || '',
                      data.description || ''
                    )
                  "
                >
                  @if (removeProjectGroup(data.projectName).length) {
                    Компонент:
                    {{ removeProjectGroup(data.projectName) }}
                    @if (data.description?.length) {
                      <br />
                    }
                  }

                  {{ data.description }}
                </nz-typography>
              </td>
              <td
                nz-tooltip
                [nzTooltipTrigger]="!data.artifactHash ? null : 'hover'"
                [nzTooltipTitle]="titleTemplate"
                [nzTooltipTitleContext]="{ $implicit: data.artifactHash }"
              >
                {{ data.artifactHash | slice: 0 : 8 }}
              </td>
              <td>
                <nz-tag [nzColor]="getTagColor(data.firstPublishComment)">{{
                  data.firstPublishComment
                }}</nz-tag>
              </td>
              <td>
                <button
                  nz-button
                  nzShape="round"
                  [nzLoading]="getIsArtifactDownloading(data)"
                  [disabled]="isDownloadingAllArtifacts"
                  (click)="download(data)"
                >
                  Скачать
                </button>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    }
  }

  @if (backendArtifacts$ | async; as backendArtifacts) {
    @if (backendArtifacts.length > 0) {
      <div class="cards-header">
        <h4 nz-typography>Backend артефакты</h4>
      </div>

      <nz-table #backendTable nzBordered [nzData]="backendArtifacts || []">
        <thead>
          <tr>
            <th>Название</th>
            <th>Описание</th>
            <th>Хэш</th>
            <th>Версионирование</th>
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          @for (data of backendTable.data; track $index) {
            <tr>
              <td>
                <nz-typography
                  nz-tooltip
                  nzEllipsis
                  nzTooltipPlacement="top"
                  [nzEllipsisRows]="2"
                  [nzTooltipTitle]="data.contentName"
                >
                  {{ data.contentName }}
                </nz-typography>
              </td>
              <td>
                <nz-typography
                  nz-tooltip
                  nzEllipsis
                  nzTooltipPlacement="top"
                  [nzEllipsisRows]="5"
                  [nzTooltipTitle]="
                    getDescriptionTooltipTitle(
                      data.projectName || '',
                      data.description || ''
                    )
                  "
                >
                  @if (removeProjectGroup(data.projectName).length) {
                    Компонент:
                    {{ removeProjectGroup(data.projectName) }}
                    @if (data.description?.length) {
                      <br />
                    }
                  }

                  {{ data.description }}
                </nz-typography>
              </td>
              <td
                nz-tooltip
                [nzTooltipTrigger]="!data.artifactHash ? null : 'hover'"
                [nzTooltipTitle]="titleTemplate"
                [nzTooltipTitleContext]="{ $implicit: data.artifactHash }"
              >
                {{ data.artifactHash | slice: 0 : 8 }}
              </td>
              <td>
                @if (data.firstPublishComment) {
                  <nz-tag [nzColor]="getTagColor(data.firstPublishComment)">{{
                    data.firstPublishComment
                  }}</nz-tag>
                } @else {
                  {{ data.firstPublishComment }}
                }
              </td>
              <td>
                <button
                  nz-button
                  nzShape="round"
                  [nzLoading]="getIsArtifactDownloading(data)"
                  (click)="
                    data.artifactType === 'ImageLink'
                      ? openPullModal(data.dockerImagePullCommand)
                      : download(data)
                  "
                >
                  <i nz-icon nzType="download"></i>
                  {{
                    data.artifactType === "ImageLink"
                      ? "Pull-команда"
                      : "Скачать"
                  }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    }
  }

  <div [hidden]="!documentations.getValue().length">
    <div class="cards-header">
      <h4 nz-typography>Документация</h4>
      @if (documentations.getValue().length > 1) {
        <button
          nz-button
          nzShape="round"
          [nzLoading]="isDownloadingAllDocs"
          (click)="downloadAllDocs()"
        >
          <i nz-icon nzType="download"></i>
          Скачать все
        </button>
      }
    </div>
    <nz-list nzBordered nzSize="small">
      @for (doc of documentations.getValue(); track $index) {
        <nz-list-item class="doc-wrapper">
          <div>
            <img
              src="../../../../assets/extensions/pdf.svg"
              width="50"
              height="70"
              class="image"
            />
            <span>{{ doc?.documentationFileName }}</span>
          </div>

          <button
            nz-button
            nzShape="round"
            [nzLoading]="getIsDocumentationDownloading(doc)"
            [disabled]="isDownloadingAllDocs"
            (click)="
              downloadReleaseDoc(
                doc.documentationFileName,
                doc.documentationFileKey
              )
            "
          >
            <i nz-icon nzType="download"></i>
            Скачать
          </button>
        </nz-list-item>
      }
    </nz-list>
  </div>

  <div [hidden]="!(releaseNotes$ | async)">
    <h4 nz-typography>Список изменений</h4>
    <nz-card nzBordered>
      <app-instruction-view
        [isShowCopyButton]="true"
        [instruction]="(releaseNotes$ | async) || ''"
      ></app-instruction-view>
    </nz-card>
  </div>

  <div [hidden]="!(instruction$ | async)">
    <h4 nz-typography>Инструкция</h4>
    <nz-card nzBordered>
      <app-instruction-view
        [isShowCopyButton]="true"
        [instruction]="(instruction$ | async) || ''"
      ></app-instruction-view>
    </nz-card>
  </div>
</div>

<ng-template #titleTemplate let-data>
  <app-artifacts-hash-tooltip [data]="data"></app-artifacts-hash-tooltip>
</ng-template>

<nz-modal
  nzTitle="Pull-команда"
  [(nzVisible)]="isOpenPullModal"
  [nzFooter]="null"
  [nzWidth]="600"
  (nzOnCancel)="closePullModal()"
>
  <ng-container *nzModalContent>
    <div class="modal-header">
      С помощью этой команды можно скачать Docker-образ из репозитория по тегу:
    </div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
    >
      <div class="copy-command-container" (click)="copyPullCommand()">
        {{ pullCommand }}
        <div class="copy-icon">
          <i nz-icon nzType="copy"></i>
        </div>
      </div>
    </nz-card>
  </ng-container>
</nz-modal>

<app-deb-verification-modal
  [(isVerificationModalVisible)]="isOpenVerificationModal"
>
</app-deb-verification-modal>
